import { useState } from "react";
import { Alert, Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { TextField } from "../ds";

export default function ChangePassword() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = () => {
    setError(null);
    if (!current || !next || !confirm) {
      setError("Fill in all fields.");
      return;
    }
    if (next !== confirm) {
      setError("New password and confirmation do not match.");
      return;
    }
    if (next.length < 8) {
      setError("New password must be at least 8 characters.");
      return;
    }
    setSubmitting(true);
    setTimeout(() => setSubmitting(false), 600);
  };

  return (
    <Box sx={{ maxWidth: 560, mx: "auto" }}>
      <Card>
        <CardContent sx={{ p: { xs: 2, md: 3 } }}>
          <Typography variant="h5" sx={{ mb: 0.5 }}>
            Change Password
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Use at least 8 characters. Avoid reusing old passwords.
          </Typography>

          <Stack spacing={2.5}>
            <TextField
              type="password"
              label="Current password"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              autoComplete="current-password"
            />
            <TextField
              type="password"
              label="New password"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              autoComplete="new-password"
            />
            <TextField
              type="password"
              label="Confirm new password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              autoComplete="new-password"
            />

            {error && <Alert severity="error">{error}</Alert>}

            <Button
              variant="contained"
              onClick={submit}
              disabled={submitting || !current || !next || !confirm}
              sx={{ alignSelf: "flex-start" }}
            >
              Update password
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
